import type { CandidateVacancy } from '../types';
import { mockCandidateVacancy } from './mockCandidateVacancy';

export const candidateVacancyMock: CandidateVacancy = mockCandidateVacancy();
